module.exports = __webpack_public_path__ + "static/ootb-2-s-2c135ea50fc5764c02bcba19a9b06b72.png";